import { BASE_URL } from "@api/constant";
import {
  FB_APP_ID,
  IOS_APP_STORE_ID,
  ITUNES_APP,
  OG_IMAGE,
  OG_SITE_NAME,
  ROBOTS,
} from "@config/MetaTagsConstants";
import type { GADataProps } from "@helper/getGtmData";
import { MetaTagsProps } from "@sphtech/web2-seo-schema";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function PodcastMetaData(section: string): PageMetaDataValues {
  const gaData: GADataProps = {
    level2: section,
    title: `${section}_index`,
    contentcat: 1,
    contenttype: undefined,
  };

  const metaTitle =
    "வலையொளி - Stream the Latest Podcasts: News, Entertainment, Education & More | Tamil Murasu";
  const metaDescription =
    "வலையொளி | Listen to the latest Tamil Podcasts of Singapore, Tamilnadu, India, World & Sports. சிறந்த தமிழ் வலையொளிகளை கேட்டு மகிழுங்கள்: செய்திகள், இசை, கதைகள் & மேலும்";
  const ogImage: string = new URL(OG_IMAGE, BASE_URL).toString();
  const additionalMetaDescriptors = [
    { tagName: "link", rel: "manifest", href: "/manifest.json" },
  ];

  const metaTags: MetaTagsProps = {
    title: metaTitle,
    description: metaDescription,
    slug: section,
    keywords: [
      "தமிழ் வலையொளி",
      "இன்றைய வலையொளி",
      "Latest Podcasts",
      "Latest Tamil Podcasts",
      "Latest News Podcasts",
      "Podcasts",
    ],
    robots: ROBOTS,
    fbAppId: FB_APP_ID,
    iosAppStoreId: IOS_APP_STORE_ID,
    appleItunesAppId: ITUNES_APP,
    urlOrigin: BASE_URL,
    ogTitle: metaTitle,
    ogDescription: metaDescription,
    ogSiteName: OG_SITE_NAME,
    image: ogImage,
    additionalMetaDescriptors,
  };

  return {
    gaData,
    metaTags,
  };
}
